import { Pipe, PipeTransform } from '@angular/core';
import { BadwordsService } from '../_services/badwords.service';
@Pipe({
  name: 'replaceBadwords'
})
export class ReplaceBadwordsPipe implements PipeTransform {
  constructor(private badwordService: BadwordsService) {}

  transform(value: any, args?: any): any {
    if(value == null){
      return
    }
    else{
    return this.badwordService.getBadwords().map(badwors => {
      
      badwors.forEach(badword => {
        let pattern = new RegExp('(\b|^|[^A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ])(' + badword + ')(\b|$|[^A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ])', 'gi');
        let pattern1 = new RegExp('(\b|^|[^A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ])(' + badword.toUpperCase() + ')(\b|$|[^A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ])', 'gi');
        let pattern2 = new RegExp('(\b|^|[^A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ])(' + badword.replace(/\s/g, '') + ')(\b|$|[^A-Za-z0-9\-\_ğüşöçıİĞÜŞÖÇ])', 'gi');
        let replacement = this.repeat(badword.length);
        let replacement2 = this.repeat(badword.replace(/\s/g, '').length);
        value = value.replace(pattern, replacement).replace(/İ/g, 'I');
        value = value.replace(pattern1, replacement).replace(/İ/g, 'I');
        value = value.replace(pattern2, replacement2).replace(/İ/g, 'I');
      });
      let patternphone=new RegExp("(05|5)[0-9][0-9][1-9]([0-9]){6}");
      let homephone=new RegExp("(02|2)[0-9][0-9][1-9]([0-9]){6}")
      let homephone2=new RegExp("(03|3)[0-9][0-9][1-9]([0-9]){6}")
      let patternidentity=new RegExp("[1-9]{1}[0-9]{9}[0,2,4,6,8]{1}");
   
      if(patternidentity.test(value)){
        let arrayidentity=[];
        arrayidentity=Object.values(patternidentity.exec(value)[0]);
     
        let sumİdentity :number=Number(arrayidentity[0])+Number(arrayidentity[1])+Number(arrayidentity[2])+Number(arrayidentity[3])+Number(arrayidentity[4])+Number(arrayidentity[5])+Number(arrayidentity[6])+Number(arrayidentity[7])+Number(arrayidentity[8])+Number(arrayidentity[9]);
        let sumİdentity2 :number=Number(arrayidentity[0])+Number(arrayidentity[2])+Number(arrayidentity[4])+Number(arrayidentity[6])+Number(arrayidentity[8]);
        let sumİdentity3 :number=Number(arrayidentity[1])+Number(arrayidentity[3])+Number(arrayidentity[5])+Number(arrayidentity[7]);
       
       if((sumİdentity  % 10)===Number(arrayidentity[10]) && (((sumİdentity2*7)-(sumİdentity3)) % 10)===Number(arrayidentity[9])){
        value=value.replace(patternidentity,'***********');
       }
      }
      if(patternphone.test(value) ){
        if(patternphone.exec(value)[0].startsWith('0')){
          var str=patternphone.exec(value)[0].substr(4,8);

          value=value.replace(str,'*******');

        }
        else{
        var str=patternphone.exec(value)[0].substr(3,8);
         value=value.replace(str,'*******');
        }
        
      }
      if(homephone.test(value)){
        if(homephone.exec(value)[0].startsWith('0')){
          var str1=homephone.exec(value)[0].substr(4,8);
          value=value.replace(str1,'*******');
        }
        else{
          var str1=homephone.exec(value)[0].substr(3,8);
          value=value.replace(str1,'*******');
        }
      }
      if(homephone2.test(value)){
        if(homephone2.exec(value)[0].startsWith('0')){
          var str1=homephone2.exec(value)[0].substr(4,8);
          value=value.replace(str1,'*******');
        }
        else{
          var str1=homephone2.exec(value)[0].substr(3,8);
          value=value.replace(str1,'*******');
        }
      }
     
    
     
      return value;
    })
  }
 
}
  repeat(num) {
    return new Array(num + 1).join('*');
  }
  // this.inputText.split(" ").forEach(a=>{
  //   if(a.startsWith('53')){
  //     var str=a.substr(4,8)
  //    console.log( this.inputText.replace(str,'****'));
  //   }
  // })


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_pipe/replace-badwords.pipe.ts